import * as React from 'react';
import { useModule } from '@starberry/components';
import { useFormState } from 'react-hook-form';

export const FormInputField = React.forwardRef((props, ref) => {
  const { onChange, onBlur, control, value, field, inputProps, required } = props;

  const InputField = useModule('InputField');

  const { errors } = useFormState({
    control,
    name: field.name,
    ...field,
    disabled: false,
  });

  return (
    <InputField
      {...field}
      inputProps={inputProps}
      error={errors[field.name]}
      value={value}
      ref={ref}
      onChange={() => onChange}
      onBlur={() => onBlur}
    />
  );
});

export default React.memo(FormInputField);
